/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_PrivateInputs */

const en_profile_private = /** @type {(inputs: Profile_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private`)
};

const es_profile_private = /** @type {(inputs: Profile_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privado`)
};

const fr_profile_private = /** @type {(inputs: Profile_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privé`)
};

const de_profile_private = /** @type {(inputs: Profile_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privat`)
};

const id_profile_private = /** @type {(inputs: Profile_PrivateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pribadi`)
};

/** @type {(inputs: Profile_PrivateInputs) => LocalizedString} */
const ja_profile_private = en_profile_private;

/** @type {(inputs: Profile_PrivateInputs) => LocalizedString} */
const zh_profile_private = en_profile_private;

/** @type {(inputs: Profile_PrivateInputs) => LocalizedString} */
const ar_profile_private = en_profile_private;

/** @type {(inputs: Profile_PrivateInputs) => LocalizedString} */
const it_profile_private = en_profile_private;

/** @type {(inputs: Profile_PrivateInputs) => LocalizedString} */
const ru_profile_private = en_profile_private;

/** @type {(inputs: Profile_PrivateInputs) => LocalizedString} */
const pt_profile_private = en_profile_private;

/** @type {(inputs: Profile_PrivateInputs) => LocalizedString} */
const ko_profile_private = en_profile_private;

/**
* | output |
* | --- |
* | "Private" |
*
* @param {Profile_PrivateInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const profile_private = /** @type {((inputs?: Profile_PrivateInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_PrivateInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_private(inputs)
	if (locale === "es") return es_profile_private(inputs)
	if (locale === "fr") return fr_profile_private(inputs)
	if (locale === "de") return de_profile_private(inputs)
	if (locale === "ja") return ja_profile_private(inputs)
	if (locale === "zh") return zh_profile_private(inputs)
	if (locale === "ar") return ar_profile_private(inputs)
	if (locale === "id") return id_profile_private(inputs)
	if (locale === "it") return it_profile_private(inputs)
	if (locale === "ru") return ru_profile_private(inputs)
	if (locale === "pt") return pt_profile_private(inputs)
	return ko_profile_private(inputs)
});